(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CampusDialogController', CampusDialogController);

    CampusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Campus'];

    function CampusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Campus) {
        var vm = this;

        vm.campus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.campus.id !== null) {
                Campus.update(vm.campus, onSaveSuccess, onSaveError);
            } else {
                Campus.save(vm.campus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:campusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
